// extracted by mini-css-extract-plugin
export default {"imgbox":"Banner_imgbox__IYgQV","center":"Banner_center__5ZXjo","text":"Banner_text__DjsXd","btn":"Banner_btn__zxoif"};